module.exports = ['$scope', '$location', ($scope, $location) ->
  @searchQuery = if $location.search().search then $location.search().search
  setSearch = =>
    search = {search: @searchQuery}
    search.page = 1 if $location.search().page # Reset paging if exists
    $location.search _.merge($location.search(), search)

  $scope.$watch 'searchCtrl.searchQuery', setSearch

  @
]
